import * as React from 'react'
import { BellOutlined, CheckOutlined, ClockCircleOutlined, CloseOutlined } from '@ant-design/icons';
import { Badge, Tabs, Popover, Button, notification } from 'antd';
import './noticeMessage.less'
import { connect } from 'react-redux'
import { axios_ } from '../../../tools/axios_'
import { CommonAction } from '../../common/actions'
import noData from '@/assets/images/notify/no-data.svg'

const TabPane = Tabs.TabPane
let container

class NoticeMessage extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      show: false,
      messageTotal: 0,
      toDoTotal: 0,
      message: [],//通知
      waitDo: [],//待办
      noticeType: 0,
      popVisible: false
    }
  }

  componentDidMount () {
    this.getSystemMessage(0, 1)
    container = this
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.messageCount !== nextProps.messageCount) {
      this.getSystemMessage(0, 1, nextProps.token)
    }
  }
  getSystemMessage = (flag, type, realToken) => {
    axios_({
      url: 'noticeListApi',
      method: 'get',
      params: {
        page: 1,
        limit: 5,
        readFlag: 0
      },
      headers: {
        'access-token': realToken || this.props.token,
      }
    }).then((res = {}) => {
      if (res.data.status !== 200) return
      let data = res.data.data.list || [];
      let _notifyObject = this.props.notifyCountObject
      /*通知 待办独立请求*/
      if (type === 1) {
        const message = data.filter((ele, index) => {
          return index < 5
        })
        this.setState({
          message,
          messageTotal: res.data.data.total
        })
        // console.log('messageTotal=',res.data.data.total)
        // _notifyObject.messageTotal = res.data.data.total
        Object.assign(_notifyObject,{messageTotal:res.data.data.total})
      }
      this.props.notifyCountChange(_notifyObject)
    }).catch(() => {
    })
  }
  // 全部标为已读
  markReadAll=()=>{
    axios_({
      url: 'apiMessageRead',
      method: 'put',
      params: {messageRecordId: ''},
      headers: {
        'access-token': this.props.token,
      }
    }).then(res => {
      if (res.data.status === 200) {
        this.getSystemMessage(1)
        notification.success({message: '提示', description: res.data.message, duration: 2})
        this.props.notifyChange(new Date().getTime())// 通知redux，消息数量变化了
        this.setState({popVisible: false})
      }
    }).catch(e => console.log(e))
  }

  render () {
    const {message, waitDo, noticeType, messageTotal, toDoTotal, popVisible} = this.state
    return (
      <div
        onClick={() => {
          if (!this.props.showMessage) {
            this.props.setMessageStatus(true);
            this.props.onClick && this.props.onClick();
          }
        }}
        ref={this.props.a}
        className='notice_message'>
        <Popover
          className="notice_message_popover"
          trigger="click"
          placement="bottomRight"
          open={popVisible}
          onOpenChange={visible => this.setState({popVisible: visible})}
          content={
            <div className='noticemessage_notice_box'>
              <Tabs onChange={(value) => {
                                this.setState({noticeType: value})//改 测试
                                this.getSystemMessage(0, value - 0 + 1)
                              }}
                    tabBarStyle={{display: 'flex', marginBottom: 0}}
                    defaultActiveKey="0">
                <TabPane tab={
                              <span>
                                <BellOutlined style={{fontSize: 16}} />
                                <Badge offset={[18, 5]} count={messageTotal}>通知</Badge>
                              </span>
                            }
                         key="0">
                  <div style={{maxHeight: 400, overflowY: 'auto'}}
                    // onClick={(e) => {
                    //   e.stopPropagation();
                    //   this.props.setMessageStatus(false)
                    // }}
                  >
                    {
                      !!messageTotal &&
                      <div className="total-tips">
                        <span>共{messageTotal}条未读消息</span>
                        <Button size='small'
                                icon={<CheckOutlined />}
                                onClick={()=>this.markReadAll('1')}>全部标为已读</Button>
                      </div>
                    }
                    {
                      message.length > 0 ? message.map((ele, index) => {
                        return (
                          <List
                            flagLength={message.length}
                            key={index}
                            title={ele.messageTitle}
                            content={ele.messageContent}
                            avatar = {ele.tenantImg}
                            closePop={()=>{this.setState({popVisible: false})}}
                            status='yes'
                          />
                        )
                      }) : <NoData type={'message'}/>
                    }
                  </div>
                </TabPane>

                <TabPane tab={
                              <span>
                                <ClockCircleOutlined />
                                <Badge offset={[18, 5]} count={toDoTotal}>待办事项</Badge>
                              </span>
                              }
                         key="1">
                  <div
                    style={{maxHeight: 400, overflowY: 'auto'}}
                  >
                    {
                      !!toDoTotal &&
                      <div className="total-tips">
                        <span>共{toDoTotal}条未读消息</span>
                        <Button size='small'
                                icon={<CheckOutlined />}
                                onClick={()=>this.markReadAll('2')}>全部标为已读</Button>
                      </div>
                    }
                    {
                      waitDo.length > 0 ? waitDo.map((ele, index) => {
                        return (
                          <List
                            flagLength={waitDo.length}
                            key={index}
                            title={ele.noticeTitle}
                            content={ele.noticeContent}
                            messageType={ele.messageType}
                            avatar = {ele.imgTenant}
                            closePop={ ()=>{this.setState({popVisible: false})}}
                          />
                        )
                      }) : <NoData type={'waitDo'}/>
                    }
                  </div>
                </TabPane>
              </Tabs>
              <p className='more'
                 onClick={() => {
                   this.setState({popVisible: false})
                   window.location.hash = `#/system/noticeList/${noticeType}`
                   this.props.setMessageStatus(false)
                   this.setState({popVisible: false})
                 }}>查看全部</p>
              <span
                className='close'
                onClick={() => {
                  this.props.setMessageStatus(false)
                  this.setState({popVisible: false})
                }}
              ><CloseOutlined /></span>
            </div>
          }
        >
          <Badge count={messageTotal + toDoTotal}>
            <BellOutlined style={{fontSize: 16,}} /> &nbsp;
            <span>通知</span>
          </Badge>
        </Popover>
      </div>
    );
  }
}

class List extends React.Component {
  render () {
    const { avatar, title, content = ''} = this.props
    return (
      <div
        onClick={() => {
          window.location.hash = `#/system/noticeList/${container.state.noticeType}`
          this.props.closePop()
        }}
        className='notice_list'>
        <div className="left">
          <img src={avatar} alt=""/>
        </div>
        <div className="right">
          <div className="header">
            <p className="title">{title}</p>
            <span className="unread">未读</span>
          </div>

          <p className="content">{content &&content.length>100?(content.substr(0,100)+'...'):content}</p>
        </div>
        {/*{*/}
          {/*(this.props.flagLength > 0) && this.props.title !== '无待办' ?*/}
            {/*<span style={{color: '#1890ff'}} className='no'>未读</span> : null*/}
        {/*}*/}
      </div>
    )
  }
}

class NoData extends React.Component {
  render () {
    return(
      <div className="no-notify-data">
        <img src={noData} alt=""/>
        {
          this.props.type === 'message'?
            <p>没有未读通知</p> :
            <p>没有待办事项</p>
        }
      </div>
    )
  }
}

function mapState (state) {
  return {
    token: state.token,
    showMessage: state.showMessage,
    messageCount: state.messageCount,
    notifyCountObject: state.notifyCountObject,
    notifyCountChange: state.notifyCountChange
  }
}

export default connect(mapState, {...CommonAction})(NoticeMessage)
